import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import es from "./locales/es.json";
import en from "./locales/en.json";

const STORAGE_KEY = "ddx.language";

function detectInitialLanguage(): "es" | "en" {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "es" || stored === "en") return stored;
  } catch {
    /* localStorage unavailable (private mode, tests) — fall through */
  }
  return typeof navigator !== "undefined" && navigator.language?.toLowerCase().startsWith("en")
    ? "en"
    : "es";
}

void i18next.use(initReactI18next).init({
  resources: { es: { translation: es }, en: { translation: en } },
  lng: detectInitialLanguage(),
  fallbackLng: "es",
  interpolation: { escapeValue: false },
});

export function setLanguage(lang: "es" | "en"): void {
  void i18next.changeLanguage(lang);
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    /* localStorage unavailable — language still changes for this session */
  }
}

export default i18next;
